import React, { useEffect, useState } from "react";
import divider from "../../assets/bg/divider.png";
import DetectDevice from "../../data/DetectDevice";
import mouse from "../../assets/icons/mouse.svg";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import ContactSection from "../../components/ContactSection";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import student1 from "../../assets/images/student1.png";
import student2 from "../../assets/images/student2.png";
import student3 from "../../assets/images/student3.png";
import student4 from "../../assets/images/student4.png";
import Rating from "@mui/material/Rating";
import student5 from "../../assets/images/student5.png";
import ArrowRightIcon from "@mui/icons-material/ArrowRightAlt";
import GetVideos from "../../actions/GetVideos";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";

import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ModalStyle from "../../data/ModalStyle";
import Close from "@mui/icons-material/Close";
import SetPage from "../../data/SetPage";
import AlumniSection from "./AlumniSection";
import ENDPOINT from "../../data/ENDPOINT";
import axios from "axios";
import CoursesCategory from "../courses/CoursesCategory";
import UserEngagement from "./UserEngagement";
import MobileHome from "./MobileHome";
import PlacementCompanies from "./PlacementCompanies";
import SuccessStories from "./SuccessStories";
import NavbarCourseSearch from "../../components/NavbarCourseSearch";
import SearchCourses from "../../actions/SearchCourses";
import Gallery from "../gallery/Gallery";
import ReelsCta from "../studentpass/ReelsCta";
import { Helmet } from "react-helmet";
import SaveUserEvent from "../../actions/SaveUserEvent";
import heroImg1 from "../../assets/images/homepage/hero1.jpeg";
import heroImg2 from "../../assets/images/homepage/hero2.jpeg";
import heroImg3 from "../../assets/images/homepage/hero3.jpeg";
import heroImg4 from "../../assets/images/homepage/hero4.jpeg";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import CustomVideoPlayer from "../../components/elements/CustomVideoPlayer";
import CollegesBusinessCta from "./CollegesBusinessCta";
import { useActionsContext } from "../../context/ActionsContext";
import { VolumeUp } from "@material-ui/icons";
import HomeDesktopReviews from "./HomeDesktopReviews";
import SecurityHeaders from "../../data/SecurityHeaders";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GroupIcon from "@mui/icons-material/Group";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import { FaStar } from "react-icons/fa";
import about1 from "../../../src/assets/about1.png";
import about2 from "../../../src/assets/about2.png";
import about3 from "../../../src/assets/about3.png";

import HackingReview from "../../components/updatehackinginternship/HackingReview";
import WhyChoseUs from "../../components/WhyChoseUs";
import Contact from "../../actions/support/Contact";
import CoursesDesign1 from "../../components/OnlineCoursesLyfax";
import Placements from "../../components/updatehackinginternship/HackingPlacements";

const HomePage = ({ account }) => {
  const [results, setresults] = useState(null);
  const [mobile, setmobile] = useState(false);
  const device = DetectDevice();
  const { user } = useContext(AuthContext);
  const { search, ShowSearch, HideSearch } = useActionsContext();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [searchFocused, setSearchFocused] = useState(false);

  const handleSearchChange = async (e) => {
    const val = e.target.value;
    setSearchQuery(val);
    if (val.length > 2) {
      const res = await SearchCourses({
        payload: {
          category: "courses",
          limit: 6,
          search: val
        }
      });
      if (res && res.status === "success") {
        setSearchResults(res.data);
      }
    } else {
      setSearchResults(null);
    }
  };

  useEffect(() => {
    SetPage(null);

    //  //console.log(device)
    if (device === "mobile") {
      setmobile(true);
    } else {
      setmobile(false);
    }
    NewVideos();
  }, []);

  const [scrollsuggestion, setscrollsuggestion] = useState(false);

  const [carousel, setcarousel] = useState(false);

  const [videos, setvideos] = useState(null);
  const NewVideos = async () => {
    const res = await GetVideos({ payload: { limit: 2 } });
    if (res) {
      //  //console.log("got "+JSON.stringify(res))
    }
    if (res.status === "success") {
      setvideos(res.videos);
    }
  };

  const [demo, setdemo] = useState(false);
  const style = {
    width: 500,
  };

  const [query, setquery] = useState(null);

  const [statistics, setstatistics] = useState(null);

  useEffect(() => {
    window.addEventListener("scroll", TogglePrime);
  }, []);

  const TogglePrime = () => {
    const video = document.getElementById("prime-video1");
    if (video) {
      const screenheight = window.innerHeight;
      const videoposition = parseInt(
        video.getBoundingClientRect().top.toFixed(),
      );

      if (videoposition + 200 < screenheight && videoposition > -100) {
        video.play();

        if (video.onplaying) {
          video.removeAttribute("muted");
        }
        if (video.onplaying && parseInt(video.currentTime) > 5) {
        }
      } else {
        if (video.onplaying) {
          video.pause();
        }
      }
    }
  };
  const NewOpenSearch = () => { };
  const [loginprompt, setloginprompt] = useState(false);
  const [displaysearch, setdisplaysearch] = useState(false);

  const [studentactivities, setstudentactivities] = useState(false);
  const [features, setfeatures] = useState(false);
  const [reviews, setreviews] = useState(false);

  const [muted, setmuted] = useState(true);
  // const courses = [
  //   {
  //     id: 1,
  //     title: "Wordpress Website Development",
  //     type: "SELF PACED",
  //     image:
  //       "https://upload.wikimedia.org/wikipedia/commons/2/20/WordPress_logo.svg",
  //     rating: 5,
  //     date: "31st Jan 2026",
  //     enrolled: 538,
  //     price: 1768,
  //     oldPrice: 2999,
  //     seats: "20 seats left",
  //     badgeColor: "#1e88e5",
  //   },
  //   {
  //     id: 2,
  //     title: "Human Resource Management",
  //     type: "SELF PACED",
  //     image:
  //       "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg",
  //     rating: 5,
  //     date: "31st Jan 2026",
  //     enrolled: 742,
  //     price: 1768,
  //     oldPrice: 2999,
  //     seats: "19 seats left",
  //     badgeColor: "#1e88e5",
  //   },
  //   {
  //     id: 3,
  //     title: "C language Masterclass for Students",
  //     type: "LIVE",
  //     image:
  //       "https://images.pexels.com/photos/5380642/pexels-photo-5380642.jpeg",
  //     rating: 5,
  //     date: "31st Jan 2026",
  //     enrolled: 956,
  //     price: 5799,
  //     oldPrice: 8999,
  //     seats: "7 seats left",
  //     badgeColor: "#ff3d00",
  //   },
  // ];

  const getCourses = async () => {
    console.log(getCourses);
    setLoading(true);
    try {
      const data = new FormData();
      if (device) data.append("device", device);
      const res = await axios.post(
        ENDPOINT + `get-courses.php`,
        data,
        SecurityHeaders,
      );
      console.log(res.data);

      if (res && res.data && res.data.status === "success") {
        setCourses(res.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, [device]);
  //   const loadCourses = async ({payload}) => {
  //   const data = new FormData()

  //   data.append("mode",payload.mode)
  //   if(payload.limit){
  //        data.append("limit",payload.limit)
  //   }
  //   if(payload.device){

  //        data.append("device",payload.device)
  //   }
  //   const res = await
  //   axios.post(ENDPOINT+`get-courses.php`,data,SecurityHeaders)
  //   if(res){

  //        return res.data
  //   }
  // };

  //   useEffect(() => {
  //   loadCourses();
  // }, []);

  const renderStatCards = () =>
    [
      {
        icon: <GroupIcon style={{ fontSize: 26 }} />,
        value: "1200+",
        label: "Students Trained",
        slug: "students",
      },
      {
        icon: <EmojiEmotionsIcon style={{ fontSize: 26 }} />,
        value: "100%",
        label: "Satisfaction",
        slug: "satisfaction",
      },
      {
        icon: <MenuBookIcon style={{ fontSize: 26 }} />,
        value: "10+",
        label: "Expert Courses",
        slug: "courses",
      },
    ].map((stat) => (
      <div
        key={stat.label}
        className={`stats-card stats-card-${stat.slug}`}
        style={{
          flex: 1,
          background: "#fff",
          border: "1px solid #f1e7dd",
          borderRadius: 16,
          padding: "18px 16px",
          boxShadow: "0 8px 22px rgba(17,24,39,.05)",
        }}
      >
        <span
          style={{
            width: 46,
            height: 46,
            borderRadius: 12,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255,129,68,.12)",
            color: "#f4611e",
            marginBottom: 12,
          }}
        >
          {stat.icon}
        </span>
        <div
          style={{
            fontSize: 26,
            fontWeight: 800,
            color: "#12263a",
            lineHeight: 1.1,
          }}
        >
          {stat.value}
        </div>
        <div
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: "#6b7280",
            marginTop: 4,
          }}
        >
          {stat.label}
        </div>
      </div>
    ));

  return (
    <>
      <Helmet>
        <title>
          SiliconMinds | India's Best Career-Focused Training Programs
        </title>
        <meta
          name="description"
          content="SiliconMinds is India's no1 training platform with guaranteed placements | online training | offline training | pre-recorded courses | online courses | offline courses"
        />
      </Helmet>

      <div className="content home-page">
        <Modal open={demo} onClose={() => setdemo(false)}>
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Introduction</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setdemo(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                autoPlay
                src="https://skillsuprise.com/data/videos/demo.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>

        <Modal open={features} onClose={() => setfeatures(false)}>
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Features</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setfeatures(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                poster="https://skillsuprise.com/data/images/features.png"
                autoPlay
                src="https://skillsuprise.com/data/videos/features.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>

        <Modal
          open={studentactivities}
          onClose={() => setstudentactivities(false)}
        >
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Student Activities</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setstudentactivities(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                poster="https://skillsuprise.com/data/images/student-activities.png"
                autoPlay
                src="https://skillsuprise.com/data/videos/student-activities.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>

        <Modal open={reviews} onClose={() => setreviews(false)}>
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Students Reviews</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setreviews(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                poster="https://skillsuprise.com/data/images/student-reviews.png"
                autoPlay
                src="https://skillsuprise.com/data/videos/student-reviews.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>
        <section className="border-bottom">
          <div className="w-100 hero sm-pt-10 mt-2">
            <div className="container ">
              <div className="flex-wrap d-flex justify-content-between align-items-center">
                {/* RIGHT (desktop): photo collage — arranged like heronew4.png */}
                <div className="col-12 col-lg-6 mt-2 order-2 order-lg-2 hero-media-col">
                  <div style={{ display: "flex", gap: 16, width: "100%", maxWidth: 560, margin: "0 auto" }}>
                    {/* all photos same size (4:3) — staggered two columns for a clean collage */}
                    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 20 }}>
                      <img src={heroImg1} alt="SiliconMinds" style={{ width: "100%", aspectRatio: "9 / 8", objectFit: "cover", borderRadius: 14, border: "4px solid #fff", boxShadow: "0 12px 28px rgba(0,0,0,.16)", transform: "rotate(-2deg)" }} />
                      <img src={heroImg4} className="d-none d-md-block" alt="SiliconMinds" style={{ width: "100%", aspectRatio: "9 / 8", objectFit: "cover", borderRadius: 14, border: "4px solid #fff", boxShadow: "0 12px 28px rgba(0,0,0,.16)", transform: "rotate(2deg)" }} />
                    </div>
                    <div className="hero-second-col">
                      <img src={heroImg3} alt="SiliconMinds" style={{ width: "100%", aspectRatio: "9 / 8", objectFit: "cover", borderRadius: 14, border: "4px solid #fff", boxShadow: "0 12px 28px rgba(0,0,0,.16)", transform: "rotate(2deg)" }} />
                      <img src={heroImg2} className="d-none d-md-block" alt="SiliconMinds" style={{ width: "100%", aspectRatio: "9 / 8", objectFit: "cover", borderRadius: 14, border: "4px solid #fff", boxShadow: "0 12px 28px rgba(0,0,0,.16)", transform: "rotate(-2deg)" }} />
                    </div>
                  </div>

                  {/* stats — shown below the images on tablet/mobile only */}
                  <div
                    className="d-lg-none mt-4 mx-auto d-flex justify-content-center hero-stats-mobile"
                    style={{ gap: 12, maxWidth: 560 }}
                  >
                    {renderStatCards()}
                  </div>
                </div>

                {/* LEFT: text (left-aligned on desktop) */}
                <div className="col-12 col-lg-6 mt-2 text-center text-lg-start order-1 order-lg-1 hero-text-col">
                  <h1 className="prime-title text-dark home-title animate-fadeInUp">
                    Master VLSI with Industry Ready Training from
                  </h1>
                  <h1 className="prime-description text-siliconMinds-orng animate-fadeInUp">
                    SiliconMinds Experts
                  </h1>

                  {/* About the platform — unique website description */}
                  <p
                    className="hero-desc animate-fadeInUp text-secondary mt-3 mb-0 mx-auto ms-lg-0 d-none d-lg-block"
                    style={{fontSize: 16, lineHeight: 1.75 }}
                  >
                    Specialised in VLSI &amp; semiconductor training institute that shapes
                    engineering students into{" "}
                      industry-ready chip design engineers
                   
                    . Master Design Verification, Physical Design, DFT and RTL through
                    hands-on labs, live mentor-led classes and real silicon projects,
                    backed by dedicated placement support at every step.
                  </p>

                  {/* Key highlights */}
                  {/* <div
                    className="animate-fadeInUp mt-3 d-flex flex-wrap justify-content-center justify-content-lg-start"
                    style={{ gap: 8 }}
                  >
                    {[
                      "Hands-on VLSI Labs",
                      "Live Expert Mentors",
                      "Placement Assistance",
                      "Real Industry Projects",
                    ].map((item) => (
                      <span
                        key={item}
                        style={{
                          background: "rgba(255,129,68,.12)",
                          color: "#e2661f",
                          fontWeight: 600,
                          fontSize: 13.5,
                          padding: "7px 14px",
                          borderRadius: 999,
                          border: "1px solid rgba(255,129,68,.22)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item}
                      </span>
                    ))}
                  </div> */}

                  <div className="home-search animate-fadeInUp mt-3">
                    <div
                      className="mx-auto ms-lg-0"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        maxWidth: 630,
                        background: "#fff",
                        border: "1px solid #eceef2",
                        borderRadius: 999,
                        boxShadow: "0 10px 30px rgba(17,24,39,.08)",
                        padding: 6,
                      }}
                    >
                      {/* search field — opens the course search */}
                      <div className="position-relative w-100 flex-grow-1">
                        <div className="d-flex align-items-center" style={{ padding: "8px 16px" }}>
                          <SearchIcon style={{ color: "#9aa1ab", fontSize: 24, marginRight: 10 }} />
                          <input
                            type="text"
                            style={{
                              border: "none",
                              outline: "none",
                              background: "transparent",
                              fontSize: "16px",
                              width: "100%",
                              color: "#1e293b",
                            }}
                            placeholder="Search a course..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onFocus={() => setSearchFocused(true)}
                            onBlur={() => setTimeout(() => setSearchFocused(false), 200)}
                          />
                        </div>

                        {searchFocused && searchResults && searchResults.length > 0 && (
                          <div className="search-suggestions shadow-lg border position-absolute bg-white rounded-3 p-2 w-100" style={{ zIndex: 1000, top: "52px", left: 0 }}>
                            {searchResults.map((result) => (
                              <Link
                                key={result.course_url}
                                className="d-flex align-items-center gap-2 p-2 hover-bg-light text-decoration-none text-dark rounded-2"
                                to={"/course/" + result.course_url + "/" + result.mode}
                                onClick={() => {
                                  SaveUserEvent({
                                    payload: {
                                      session: (user && user.SessionId) ? user.SessionId : null,
                                      page: window.location.pathname,
                                      action: `HomePage-search-suggestion-${result.course_url}`,
                                    },
                                  });
                                }}
                              >
                                <SearchIcon style={{ fontSize: 16, color: "#94a3b8" }} />
                                <div className="text-start">
                                  <p className="mb-0 text-truncate font-weight-semibold" style={{ fontSize: "13px", maxWidth: "280px" }}>{result.course_title}</p>
                                  <p className="mb-0 text-secondary" style={{ fontSize: "11px" }}>{result.mode} course</p>
                                </div>
                              </Link>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Browse Courses -> /courses */}
                      <Link
                        to="/courses"
                        onClick={() => {
                          SaveUserEvent({
                            payload: {
                              session:
                                user != null || user != undefined
                                  ? user.SessionId
                                  : null,
                              page: window.location.pathname,
                              action: "HomePage-browsecourses",
                            },
                          });
                        }}
                        style={{
                          flexShrink: 0,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          background:
                            "linear-gradient(90deg, #ff9838 0%, #f4611e 100%)",
                          color: "#fff",
                          fontWeight: 700,
                          fontSize: 15,
                          textDecoration: "none",
                          padding: "12px 22px",
                          borderRadius: 999,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Browse Courses
                        <ArrowRightIcon style={{ fontSize: 22 }} />
                      </Link>
                    </div>
                  </div>
                  <div className="d-flex mt-2 mx-auto">
                    <div class="d-flex align-items-center"></div>


                    <div className="p-0 w-100 ">
                      {/* <div className="mt-3 d-flex justify-content-center animate-fadeInUp ">
                        <AvatarGroup>
                          <Avatar
                            alt="Remy Sharp"
                            src={student1}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Travis Howard"
                            src={student2}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Trevor Henderson"
                            src={student5}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Cindy Baker"
                            src={student3}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Agnes Walker"
                            src={student4}
                            sx={{ width: 50, height: 50 }}
                          />
                        </AvatarGroup>
                      </div> */}
                      {/* <h5 className="mt-3 text-secondary animate-fadeInUp text-center">
                        Kick-start your career with SiliconMinds !{" "}
                      </h5> */}
                      {!user && (
                        <Link
                          onClick={() => {
                            SaveUserEvent({
                              payload: {
                                session:
                                  user != null || user != undefined
                                    ? user.SessionId
                                    : null,
                                page: window.location.pathname,
                                action: "HomePage-registerbutton",
                              },
                            });
                          }}
                          to="/signup"
                          className="mt-2 mt-md-4 animate-fadeInUp btn d-md-none d-flex align-items-center w-fit btn-siloconMinds-orng rounded-pill sm-14 btn-sm text-dark mx-auto"
                        >
                          REGISTER FOR FREE
                          <ArrowRightIcon
                            className="text-dark"
                            fontSize="large"
                          />
                        </Link>
                      )}
                      <div className="d-none d-lg-block">
                        <div
                          className="mt-2 mt-md-5 d-flex justify-content-lg-start"
                          style={{ gap: 14, maxWidth: 560 }}
                        >
                          {renderStatCards()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row gx-4 gy-3 text-center text-md-start mt-2 justify-content-center stats-row d-none d-md-flex">
                  {/* <div className="col-6 col-md-3 mb-3 d-flex align-items-center stats-col">
                <RecordVoiceOverIcon style={{ fontSize: 75 }} color="primary" className="me-2 icon-stats" />
                <h5 className="fw-bold mt-2 text-dark stat-text">
                  10+<br />Instructors
                </h5>
              </div> */}
                </div>
                {/* <div className="col-lg-5 sm-mt-20 sm-mb-20 animate-fade">
                  <img src={heroimage} className="w-100" />
                </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* {device === "mobile" ? (
          <>
            <div className="mt-5">
              <MobileHome />
            </div>
          </>
        ) : (
          <div className="mt-3">
            <CoursesCategory
              offline={true}
              live={true}
              selfpaced={true}
              specialization={true}
            />
          </div>
        )} */}

        {device === "mobile" ? (
          <>
            <section>
              <CoursesDesign1 />
            </section>

            <section>
              <div className="container mt-0">
                <PlacementCompanies />
              </div>
            </section>
            <div>
              <Placements />
            </div>

            <div>
              <HackingReview />
            </div>

            <div className="mt-2 pt-2">
              <WhyChoseUs />
            </div>
            <div >
              <ContactSection />
            </div>
          </>
        ) : (
          <>
            <section>
              <CoursesDesign1 />
            </section>

            <section>
              <div className="container mt-0">
                <PlacementCompanies />
              </div>
            </section>
            <div>
              <Placements />
            </div>

            <div>
              <HackingReview />
            </div>

            <div className="mt-2 pt-2">
              <WhyChoseUs />
            </div>
            <div >
              <ContactSection />
            </div>
          </>
        )}
        {/* 
        <div
          className={device === "mobile" ? "" : "mt-0  pb-0  sm-mb-0 sm-mt-0"}
        >
          <div className="mt-5 mt-md-5 pt-0 pt-md-5">
            <Gallery limit={device === "mobile" ? 8 : 9} />
          </div>
        </div> */}
        {/* <div className="pb-0 pb-sm-5 mb-md-5 pt-0 pt-md-4 pt-lg-5 animate-fade">
          <CollegesBusinessCta />
        </div> */}
        {/* <div className="pb-5 mb-5 animate-fade">
          <ContactSection />
        </div> */}

        <style>
          {`
        .hero-second-col {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        @media (min-width: 992px) {
          .hero-second-col {
            margin-top: 50px !important;
          }
        }

        .courses-wrapper{
          padding:40px 20px;
          font-family: 'Segoe UI', sans-serif;
          background:#fff;
        }
        .courses-title{
          text-align:center;
          color:#ffb300;
          font-size:38px;
          font-weight:700;
        }
        .courses-sub{
          text-align:center;
          color:#8fa2c1;
          max-width:900px;
          margin:10px auto 30px;
          font-size:17px;
        }
        .search-box{
          max-width:900px;
          margin:0 auto 40px;
          display:flex;
          gap:15px;
          align-items:center;
          flex-wrap:wrap;
          justify-content:center;
        }
        .search-box input{
          flex:1;
          min-width:250px;
          padding:14px 20px;
          border-radius:40px;
          border:2px solid #bcd1ff;
          outline:none;
          font-size:16px;
        }
        .view-btn{
          padding:14px 30px;
          border-radius:30px;
          border:1px solid #ffb300;
          background:#fff;
          color:#ffb300;
          font-weight:600;
          cursor:pointer;
          transition:all 0.3s ease;
          white-space:nowrap;
        }
        .view-btn:hover{
          background:#ffb300;
          color:#fff;
          transform:translateY(-2px);
          box-shadow:0 4px 12px rgba(255,179,0,0.3);
        }
       .cards{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
  gap:24px;
}

.card1{
  border-radius:20px;
  overflow:hidden;
  display:flex;
  flex-direction:column;
  background:#fff;
  box-shadow:0 2px 8px rgba(0,0,0,0.1);
  transition:all 0.3s ease;
}

.card1:hover{
  transform:translateY(-8px);

}

.card1 img{
  width:100%;
  height:180px;
  object-fit:cover;
}

.badge{
  position:absolute;
  top:14px;
  left:14px;
  padding:6px 14px;
  border-radius:8px;
  color:#fff;
  font-size:13px;
  font-weight:600;
}

.card-body{
  padding:16px 18px 10px;
}

.rating{
  text-align:right;
  color:#ffb300;
  font-size:16px;
  margin-bottom:6px;
}

.card-title{
  font-size:18px;
  font-weight:700;
  line-height:1.3;
  margin-bottom:10px;
  color:#222;
}

.info{
  display:flex;
  justify-content:space-between;
  align-items:center;
  font-size:14px;
  color:#9aa6bf;
  margin-bottom:8px;
}

.price-row{
  display:flex;
  justify-content:space-between;
  align-items:flex-end;
  margin-top:8px;
}

.price{
  font-size:18px;
  font-weight:700;
  color:#0a9b52;
}

.old{
  font-size:13px;
  color:#9aa6bf;
  margin-left:6px;
  text-decoration:line-through;
}

.seats{
  font-size:14px;
  font-weight:600;
  color:#ff3d00;
}

.enroll{
  margin:12px 16px 16px;
  background:linear-gradient(90deg,#ffb300,#ffca28);
  border:none;
  border-radius:14px;
  padding:12px;
  color:#fff;
  font-size:15px;
  font-weight:700;
  cursor:pointer;
  transition:all 0.3s ease;
}

.enroll:hover{
  transform:scale(1.02);
  box-shadow:0 4px 12px rgba(255,179,0,0.4);
}

@media(max-width:768px){
  .search-box{
    flex-direction:column;
    gap:10px;
  }
  .search-box input{
    width:100%;
    min-width:unset;
  }
  .view-btn{
    width:100%;
  }
  .courses-title{
    font-size:28px;
  }
  .courses-sub{
    font-size:15px;
  }
  .cards{
    grid-template-columns:1fr;
    gap:16px;
  }
}

/* ===== HERO RESPONSIVE FIXES ===== */
/* tablet (below desktop): center the collage + stats under the title */
@media (max-width: 991px) {
  .hero-media-col { text-align: center; }
  .hero-stats-mobile { margin-left: auto !important; margin-right: auto !important; }
}
/* large phones / small tablets: tighten hero height + breathing room above title */
@media (max-width: 575px) {
  .hero { min-height: auto !important; padding-bottom: 18px !important; }
  .hero-text-col { padding-top: 26px !important; }
  .hero-stats-mobile { margin-top: 16px !important; margin-bottom: 0 !important; }
}
/* very small phones: show only two stat cards (drop Satisfaction) */
@media (max-width: 450px) {
  .stats-card-satisfaction { display: none !important; }
}
        `}
        </style>
      </div>
    </>
  );
};

export default HomePage;
